var _defs, _g, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prev-icon-svg",
    version: 1.1,
    viewBox: "0 0 154.5 154.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base_Circle",
    className: "st32"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 627.8,
    cy: -1308.6,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 1306.2,
    cy: -1308.6,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 1524.8,
    cy: -1308.6,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 1080.8,
    cy: -1308.6,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 175.8,
    cy: -1307.6,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 855.2,
    cy: -1313.6,
    r: 77.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st31",
    cx: 403.8,
    cy: -1308.6,
    r: 77.2
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st33",
    cx: 77.2,
    cy: 77.2,
    r: 77.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M123.4,76.9c.1,4-1.7,4.7-4.8,4.7H46.1s27.6,27.6,27.6,27.6c1.8,1.8,1.7,4.8-.3,6.5s-4.4,1.2-6-.4l-34.9-34.9c-1.7-1.7-1.7-4.5,0-6.2l35-35c1.7-1.7,4.5-1.7,6.2,0,1.7,1.7,1.7,4.5,0,6.2l-27.6,27.6h73.7c2.5.1,3.5,2.3,3.6,4.1Z"
  })));
};
export default __webpack_public_path__ + "static/media/PreviousIcon.e464fa31.svg";
export { SvgComponent as ReactComponent };